<template>
    <div id="checkbox" v-if="datalaod" >
        <div class="cbox" v-if="!disabled">
             <span class="cborder1"   v-if="type=='checkbox1'" :class="{'cbcheck':ischecked}" @click="checkedclick"><img v-if="ischecked" src="@/assets/gou.png"></span>
             <span class="cborder2" v-if="type=='checkbox2'" :class="{'cbcheck':ischecked}" @click="checkedclick"><i v-if="ischecked"></i></span>
             <span class="clabel">{{ lable }}</span>
        </div>
        <div class="cbox" v-if="disabled">
             <span class="cborder1"   v-if="type=='checkbox1'" :class="{'cbcheck1':ischecked,'nopoint':disabled}"><img v-if="ischecked" src="@/assets/gouH.png"></span>
             <span class="cborder2" v-if="type=='checkbox2'" :class="{'cbcheck1':ischecked,'nopoint':disabled}"><i v-if="ischecked"></i></span>
             <span class="clabel">{{ lable }}</span>
        </div>
        
    </div>
</template>

<script>

    export default {
        name:"Select",
        data(){
            return{
                ischecked:false,
                checklist:[],
                datalaod:false            

            }
        },
        props:{
            modelValue:{
                type: Array,
                default:[]
            },
            value:{
                // type:String,
                default:""
            },
            type:{
                type:String,
                default:"checkbox1"
            },
            lable:{
                type:String,
                default:""
            },
            disabled:{
                type:Boolean,
                default:false
            }

        },
        computed:{
            get(){
                this.checklist=this.modelValue
                this.oncheck() ;
            }
            
        },
        watch:{
            checklist(newVal) {
                   this.oncheck()  
            },
            get() {
            }
            
        }
        ,
        async mounted(){
           this.checklist=this.modelValue
        },
        methods:{
            hideList(e){
                let s1=this.$refs.sel
                
                if((s1!==null||s1!=undefined)&&!s1.contains(e.target)){
                    this.pageselect_show=false
                    this.page_shou_str=""
                    this.opserchList=this.optionList
                    this.is_show_pla=true
                    window.removeEventListener('click', this.hideList)
                    
                }
               
            },
            oncheck(){
                
                if(this.modelValue!=undefined){
                    this.checklist=this.modelValue
                    this.datalaod=true
                    if(this.value.length>0||this.value!=""){
                        let isin=this.checklist.includes(this.value);
                        if(isin){
                            this.ischecked=true
                        }else{
                            this.ischecked=false
                        }
                    }
                    
                }
                
                
            },
            checkedclick(){
                if(this.ischecked){
                    let index = this.checklist.findIndex(d => d == this.value)
                    this.checklist.splice(index, 1)
                    this.ischecked=false
                    
                }else{
                    this.checklist.push(this.value)
                    this.ischecked=true
                }
                this.$emit('update:modelValue', this.checklist)
                this.$emit('change')

            }
        }
    }
</script>
<style scoped>
#checkbox{
    width: auto;
    height: 100%;
    float: left;
    
}
#checkbox .cbox{
    width: auto;
    height: 100%;
    float: left;
    margin: auto 0;
    
}
#checkbox .cbox .cborder1{
    width: 15px;
    height: 15px;
    float: left;
    border-radius: 2px;
    border: 2px solid #ccc;
    position: relative;
    top: 50%;
    margin-top: -7px;
}
#checkbox .cbox .cborder1.cbcheck{
    border: none;
    background-color: #227bef;
}
#checkbox .cbox .cborder1 img{
    width: 10px;
    height: 10px;
    margin: 2px;
    float: left;
}
#checkbox .cbox .cborder2{
    width: 15px;
    height: 15px;
    float: left;
    margin:0;
    border-radius: 2px;
    border: 2px solid #ccc;
    top: 50%;
    margin-top: -7px;
    position: relative;
}
#checkbox .cbox .cborder2.cbcheck{
    border: 2px solid #227bef;
}
#checkbox .cbox .cborder2 i{
    width: 10px;
    height: 10px;
    margin-top: 1px;
    margin-left: 1px;
    float: left;
    padding: 0;
    background-color: #227bef;
}
#checkbox .cbox .clabel{
    width: auto;
    height: 30px;
    float: left;
    font-size: 16px;
    margin: 0;
    line-height: 30px;
    position: relative;
    top: 50%;
    margin-top: -15px;
    margin-left: 5px;
}
#checkbox .cbox .cborder1.cbcheck1{
    border: 1px solid #ccc;
    background-color:transparent;
}
#checkbox .cbox .cborder2.cbcheck1{
    border: 2px solid #ccc;
}
#checkbox .cbox .cborder2.cbcheck1 i{
    background-color: #ccc;
}
#checkbox .cbox .cborder1.nopoint{
    cursor: not-allowed;
}
#checkbox .cbox .cborder2.nopoint{
    cursor: not-allowed;
}
</style>